import React, { useState, useEffect } from "react";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AddUser = (props) => {
  const token = sessionStorage.getItem("token");
  const decodedToken = jwt_decode(token);
  const companyid = decodedToken.companyid;
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [body, setBody] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [roles, setRoles] = useState([]);
  const [rowRecord, setRowRecord] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    phone: "",
    role_id: "",
    companyid: "",
    userrole: "",
    status: "",
  });

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const result = await schoolApi.getAllRolesByCompanyId(companyid);
        if (result.success) {
          setRoles(result.result);
        } else {
          setRoles([]);
        }
      } catch (error) {
        setRoles([]);
      }
    };
    fetchRoles();
  }, [companyid]);

  useEffect(() => {
    if (props?.parent) {
      setRowRecord(props.parent);
      setSelectedEmployee(props.parent.employee);
    }
  }, [props.parent]);

  useEffect(() => {
    const init = async () => {
      try {
        const result = await schoolApi.fetchStaffContacts();
        if (result.success) {
          setBody(result.contacts);
        } else {
          toast.error("Failed to fetch staff contacts.");
          setBody([]);
        }
      } catch (error) {
        console.error("Error occurred:", error);
      }
    };
    init();
  }, []);
  console.log("rowRecord == ", rowRecord);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const inputPhone = e.target.value.replace(/\D/g, "").slice(0, 10);
      setRowRecord((prevRecord) => ({ ...prevRecord, [name]: inputPhone }));
      return;
    }

    if(name === 'password'){

    
    const trimmedValue = e.target.value.replace(/\s/g, "");
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const isValidPassword = passwordRegex.test(trimmedValue);
    if (!isValidPassword) {
      setPasswordError("Password must be 8+ chars with A-Z, a-z, 0-9 & special char.");
    } else {
      setPasswordError(""); // Clear error if valid
    }

  }

    if (name === "employee") {
      const selected = body.find((employee) => employee.id === value);

      if (selected) {
        setRowRecord((prevRecord) => ({
          ...prevRecord,
          firstname: selected.firstname,
          lastname: selected.lastname,
          email: selected.email ? selected.email : "",
          phone: selected.phone,
          password: prevRecord.password, // Retain existing password
        }));
        setSelectedEmployee(value);
      }
      return;
    }

    if (name === "role_id") {
      const selectedRole = roles.find((role) => role.id === value);
      if (selectedRole) {
        setRowRecord((prevRecord) => ({
          ...prevRecord,
          role_id: value,
          userrole: selectedRole.name,
          companyid: selectedRole.company_id,
        }));
      }
      return;
    }

    if(name === 'email'){
      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ) {
        if (value === "") {
          setEmailError("");
        } else setEmailError("Invalid email format");
      } else {
        setEmailError(""); // Clear the error if valid
      }
    }

    setRowRecord((prevRecord) => ({ ...prevRecord, [name]: value }));
  };

  const validateForm = () => {
    const { firstname, lastname, email, password, phone, role_id, status } =
      rowRecord;

    if (
      !firstname ||
      !lastname ||
      !email ||
      (!props?.parent?.id && (!password || !phone)) ||
      !role_id ||
      !status
    ) {
      toast.error("All fields are required.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('emailError-->',emailError)
    console.log('passwordError-->',passwordError)

    console.log('rowRecord-->',rowRecord);

    if(emailError){
      return
    }

    if(passwordError){
      return
    }

    if (!validateForm()) return;
    if (!rowRecord?.phone || rowRecord?.phone?.length !== 10) {
      toast.error("Enter a valid 10-digit phone number.");
      return;
    }
    
    if (!rowRecord?.password || rowRecord?.password?.length < 6) {
      toast.error("Password must contain 6 characters");
      return;
    }

    let getAllUsers;
    try {
      getAllUsers = await schoolApi.fetchUsersbyCompanyId();
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users. Please try again later.");
      return;
    }
    const editRecord = { ...rowRecord, companyid };
    if (props?.parent?.id) {
      editRecord.id = props.parent.id;

      const existingUser = getAllUsers?.userRec.find(
        (user) => user.phone === editRecord.phone && user.id !== editRecord.id
      );
      if (existingUser) {
        toast.error("User with same phone already exists!");
        return;
      }
      try {
        const response = await schoolApi.updateUser(editRecord);
        if (response.success) {
          setRowRecord(response.updateBook);
          recordSaveSuccesfully();
          setTimeout(() => navigate(`/userlist`), 1200);

          return toast.success(response.message);
        } else {
          return toast.error(
            response.updateBook || "An error occurred while saving the record."
          );
        }
      } catch (error) {
        console.error("Error updating user:", error);
        if (error.response) {
          return toast.error(
            `Error: ${error.response.data.message || "Internal server error"}`
          );
        } else {
          return toast.error("An unexpected error occurred. Please try again.");
        }
      }
    } else {
      const existingUser = getAllUsers?.userRec.find(
        (user) => user.phone === rowRecord.phone
      );

      if (existingUser) {
        toast.error("User with this number already exists!");
        return;
      }

      try {
        const response = await schoolApi.createUserbyCompanyId(editRecord);

        if (response.success) {
          recordSaveSuccesfully();
          setTimeout(() => navigate(`/userlist`), 1200);
          return toast.success("Record saved successfully!");
        } else {
          return toast.error(
            response.message || "An error occurred while saving the record."
          );
        }
      } catch (error) {
        console.error("Error creating user:", error);
        console.log(
          "error.response?.data?.messageerror.response?.data?.message",
          error.response?.data?.message
        );
        if (error.response?.data?.error?.error) {
          return toast.error(error.response?.data?.error?.error);
        } else if (error.response?.data?.errors[0].msg) {
          return toast.error(error.response?.data?.errors[0].msg);
        } else {
          return toast.error(
            "An unexpected error occurred while saving the record."
          );
        }
      }
    }
  };

  const recordSaveSuccesfully = () => {
    props.recordSaveSuccesfully();
  };

  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={props.onHide}
      className="modal-dialog-scrollable"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          User Record
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form noValidate>
                <Row className="pb-4">
                  {}
                  <Col lg={12}>
                    <Form.Group className="my-3">
                      <Form.Label>Employee</Form.Label>
                      <Form.Control
                        as="select"
                        name="employee"
                        value={selectedEmployee}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select an employee
                        </option>
                        {body.map((employee) => (
                          <option key={employee.id} value={employee.id}>
                            {employee.firstname} {employee.lastname}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label htmlFor="formBasicFirstName">
                        First Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="firstname"
                        placeholder="--First Name--"
                        value={rowRecord.firstname}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label htmlFor="formBasicLastName">
                        Last Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="lastname"
                        placeholder="--Last Name--"
                        value={rowRecord.lastname}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label htmlFor="formBasicEmail">Email</Form.Label>
                      <Form.Control
                        required
                        type="email"
                        name="email"
                        placeholder="--Email--"
                        value={rowRecord.email}
                        onChange={handleChange}
                        isInvalid={!!emailError}
                      />
                       <Form.Control.Feedback type="invalid">
                                      {emailError}
                                    </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {!props?.parent?.id && (
                    <Col lg={6}>
                      <Form.Group className="my-3">
                        <Form.Label htmlFor="formBasicPassword">
                          Password
                        </Form.Label>
                        <Form.Control
                          required
                          type="password"
                          name="password"
                          placeholder="--Password--"
                          value={rowRecord.password}
                          onChange={handleChange}
                          isInvalid={!!passwordError}
                        />
                        <Form.Control.Feedback type="invalid">
                {passwordError}
              </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  )}
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label htmlFor="formBasicPhone">Phone</Form.Label>
                      <Form.Control
                        required
                        type="phone"
                        name="phone"
                        placeholder="--Phone--"
                        value={rowRecord.phone}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label htmlFor="formBasicRoleId">Role</Form.Label>
                      <Form.Select
                        required
                        name="role_id"
                        value={rowRecord.role_id} // Use role_id directly from rowRecord
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select a role
                        </option>
                        {roles?.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {}
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        required
                        name="status"
                        value={rowRecord.status}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {props.parent?.id ? "Update User" : "Add User"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddUser;

